<template>
	<footer class="bg-dark pt-6 pt-lg-8" data-bs-theme="dark">
	  <div class="container">
		<div class="row g-4">
		  <div class="col-md-6">
			<h2>{{ $t('footer.subscribeText') }}</h2>
			<p class="mb-0">{{ $t('footer.subscribeDescription') }}</p>
		  </div>
  
		  <div class="col-md-6 col-xl-5 ms-auto">
			<form class="row row-cols-sm-auto g-2 align-items-center justify-content-md-end">
			  <div class="col-12">
				<input type="email" class="form-control">
			  </div>
			  <div class="col-12">
				<button type="submit" class="btn btn-primary m-0">{{ $t('footer.joinUs') }}</button>
			  </div>
			</form>
		  </div>
		</div>
  
		<!-- Divider -->
		<hr class="my-4 my-xl-6 opacity-1">  
		<!-- Divider -->
		<hr class="mt-xl-5 mb-0 opacity-1">
		<div class="d-md-flex justify-content-between align-items-center text-center text-lg-start py-4">
		  <ul class="nav d-flex justify-content-center gap-1 mb-0">
			<li class="nav-item">
			  <router-link class="nav-link small py-0" to="#/privacy-policy">{{ $t('footer.privacyPolicy') }}</router-link>
			</li>
			<li class="nav-item">
			  <router-link class="nav-link small py-0 pe-0" to="#/terms-conditions">{{ $t('footer.termsConditions') }}</router-link>
			</li>
		  </ul>
		</div>
	  </div>
	</footer>
  </template>
  